// NGRX
import { Action } from '@ngrx/store';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { ContactLoginHistoryModel } from '../_models/contact-login-history.model';

export enum ContactLoginHistoryActionTypes {
  ContactsLoginHistoryPageRequested = '[Contacts Login History List Page] Contacts Login History Page Requested',
  ContactsLoginHistoryPageLoaded = '[Contacts Login History API] Contacts Login History Page Loaded',
  ContactsLoginHistoryPageCancelled = '[Contacts Login History API] Contacts Login History Page Cancelled',
  ContactsLoginHistoryPageToggleLoading = '[Contacts Login History] Contacts Login History Page Toggle Loading',
  ContactLoginHistoryActionToggleLoading = '[Contacts Login History] Contacts Login History Action Toggle Loading',
  ThrowContactLoginHistoryError = '[Contacts Login History] Throw Contact Login History Error',
  ClearContactLoginHistoryErrors = '[Contacts Login History] Clear Contact Login History Errors',
}
export class ContactsLoginHistoryPageRequested implements Action {
  readonly type = ContactLoginHistoryActionTypes.ContactsLoginHistoryPageRequested;

  constructor(public payload: { id: number; page: QueryParamsModel }) {}
}

export class ContactsLoginHistoryPageLoaded implements Action {
  readonly type = ContactLoginHistoryActionTypes.ContactsLoginHistoryPageLoaded;

  constructor(
    public payload: {
      contactsLoginHistory: ContactLoginHistoryModel[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class ContactsLoginHistoryPageCancelled implements Action {
  readonly type = ContactLoginHistoryActionTypes.ContactsLoginHistoryPageCancelled;
}

export class ContactsLoginHistoryPageToggleLoading implements Action {
  readonly type = ContactLoginHistoryActionTypes.ContactsLoginHistoryPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ContactLoginHistoryActionToggleLoading implements Action {
  readonly type = ContactLoginHistoryActionTypes.ContactLoginHistoryActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowContactLoginHistoryError implements Action {
  readonly type = ContactLoginHistoryActionTypes.ThrowContactLoginHistoryError;
  constructor(public payload: { error: any }) {}
}

export class ClearContactLoginHistoryErrors implements Action {
  readonly type = ContactLoginHistoryActionTypes.ClearContactLoginHistoryErrors;
}

export type ContactLoginHistoryActions =
  | ContactsLoginHistoryPageRequested
  | ContactsLoginHistoryPageLoaded
  | ContactsLoginHistoryPageCancelled
  | ContactsLoginHistoryPageToggleLoading
  | ContactLoginHistoryActionToggleLoading
  | ThrowContactLoginHistoryError
  | ClearContactLoginHistoryErrors;
